// extracted by mini-css-extract-plugin
export default {"list":"AvatarGroup--list--YPh+9","listItem":"AvatarGroup--listItem--uwXOF","avatar":"AvatarGroup--avatar--G0dNV"};